<template>
    <div name="recent" style="width: 100%; height: 100vh; overflow-y: auto;">
        <div class="tabs">
            <span class="inactive-tab-text" @click="tabChange">최근 검색어</span>
            <span class="active-tab-text" style="margin-left: 16px;">카테고리 검색</span>
        </div>
        <div class="line"></div>
        <div v-if="categoryList" class="category-list">
            <span class="category-title">연속혈당측정기<span class="category-count-title"> {{ categoryList.cgm.count }}</span></span>
            <div class="category-element" style="margin-top: 18px;" @click="searchCategory('연속혈당측정기', 1, 3)">
                <span class="category-element-text">연속혈당측정기 <span class="category-element-count">({{ categoryList.cgm.count}})</span></span>
                <img style="width: 22p;" src="../../../assets/right_arrow3.png" />
            </div>
            <span style="margin-top: 30px;" class="category-title">일반 소모성재료<span class="category-count-title"> {{ categoryList.generalItemCount }}</span></span>
            <div class="box" style="margin-top: 22px;">
                <div :key="`general_${index}`" class="category-element" style="border-radius: 0;" v-for="(general, index) in filteredGeneralList" @click="searchCategory(categoryToString(general.category), 0, general.category)" >
                    <span class="category-element-text">{{ categoryToString(general.category) }} <span class="category-element-count">({{ general.count}})</span></span>
                    <img style="width: 22p;" src="../../../assets/right_arrow3.png" />
                </div>
            </div>

            <div style="width: 100%; display: flex; flex-direction: column;" v-if="insulinPumpList.length > 0">
                <span style="margin-top: 30px;" class="category-title">인슐린 펌프<span class="category-count-title"> {{ categoryList.insulinPumpCount }}</span></span>
                <div class="box" style="margin-top: 22px;">
                    <div :key="`pump_${index}`" class="category-element" style="border-radius: 0;" v-for="(pump, index) in insulinPumpList" @click="searchCategory(categoryToString(pump.category), 6, pump.category)" >
                        <span class="category-element-text">{{ categoryToString(pump.category) }} <span class="category-element-count">({{ pump.count}})</span></span>
                        <img style="width: 22p;" src="../../../assets/right_arrow3.png" />
                    </div>
                </div>
            </div>

            <span style="margin-top: 30px;" class="category-title">기타<span class="category-count-title"> {{ filteredEtcList[0].count }}</span></span>
             <div class="box" style="margin-top: 22px;">
                <div :key="`etc_${index}`" class="category-element" style="border-radius: 0;" v-for="(general, index) in filteredEtcList" @click="searchCategory(categoryToString(general.category), 0, general.category)" >
                    <span class="category-element-text">{{ categoryToString(general.category) }} <span class="category-element-count">({{ general.count}})</span></span>
                    <img style="width: 22p;" src="../../../assets/right_arrow3.png" />
                </div>
            </div>
            <span style="margin-top: 30px;" class="category-title">관리기기<span class="category-count-title"> {{ categoryList.managementDevice.count }}</span></span>
             <div class="box" style="margin-top: 22px;">
                <div :key="`etc_${index}`" class="category-element" style="border-radius: 0;"  @click="searchCategory('관리기기', 2, 8)" >
                    <span class="category-element-text">관리기기 <span class="category-element-count">({{ categoryList.managementDevice.count}})</span></span>
                    <img style="width: 22p;" src="../../../assets/right_arrow3.png" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'recent',
    data: function()
    {
        return {
            categoryList: null
        }
    },
    computed: {
        filteredGeneralList() {
            // v-if에서 걸러내던 조건을 여기서 처리
            return this.categoryList.generalList.filter(item => item.category !== 7);
        },
        filteredEtcList() {
            return this.categoryList.generalList.filter(item => item.category === 7);
        },
        insulinPumpList() {
            return this.categoryList.insulinPumpList ? this.categoryList.insulinPumpList : [];
        },
        filteredManagementDeviceList() {
            return this.categoryList.managementDevice.filter(item => item.category === 8);
        }
    },
    mounted: async function()
    {
        // cookies 사용 검색어 리스트 읽기
        const url = `${process.env.API_DB_ROOT}/diabetes/item/count`;                   
        const response = await axios.get(url);
        this.categoryList = response.data.data;

    },
    methods: {
        searchCategory: function(keyword, type, category)
        {
            this.$emit('searchCategory', keyword, type, category)
        },
        tabChange: function()
        {
            this.$emit('tabChange', 0)
        },
        categoryToString: function(category)
        {
            if(category === 0)
            {
                return '펜니들'
            }
            else if(category === 1)
            {
                return '혈당검사지'
            }
            else if(category === 2)
            {
                return '채혈침'
            }
            else if(category === 3)
            {
                return '연속혈당측정기'    
            }
            else if(category === 4)
            {
                return '펌프용 주사기'
            }
            else if(category === 5)
            {
               return '주사기'
            }
            else if(category === 6)
            {
                return '펌프용 주사바늘'
            }
            else if(category === 7)
            {
                return '기타'
            }
            else if(category === 11)
            {
                return '인슐린 펌프'
            }

        }
    }
}
</script>

<style scoped>
    .active-tab-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .inactive-tab-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .tabs {
        width: 100%;
        padding: 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #EDEEF0;
    }
    .line {
        background: #1E1E1E;
        width: 100px;
        height: 1.5px;
        margin-left: 116px;
    }
    .category-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 33px 16px 60px 16px;
    }
    .category-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px; /* 94.444% */
    }
    .category-count-title {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px;
    }
    .category-element {
        height: 59px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 20px;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
    }
    .category-element-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px; /* 94.444% */
    }
    .category-element-count {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px;
    }
    .box {
        width: 100%;
        border-radius: 6px;
        overflow:hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/calculator/Category.vue